/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./custom-material-push.vue?vue&type=template&id=43ab3228&scoped=true&"
import script from "./custom-material-push.vue?vue&type=script&lang=js&"
export * from "./custom-material-push.vue?vue&type=script&lang=js&"
import style0 from "./custom-material-push.vue?vue&type=style&index=0&id=43ab3228&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ab3228",
  null
  
)

export default component.exports